import { Icon } from "@chakra-ui/react";

export const LocationIcon = (props) => (
  <Icon width="7" height="7" fill="none" {...props}>
    <path
      fill="#4B4F54"
      d="M13.13 21.294c0-.11 0-.11 0 0a116.67 116.67 0 0 0 3.153-4.164c1.01-1.423 2.032-2.945 2.739-4.565.913-2.032.913-4.163 0-6.195C17.706 3.63 14.957 2 11.913 2c-.609 0-1.12.098-1.728.207-3.348.706-5.892 3.75-5.892 7.206 0 1.01.207 2.033.816 3.25.815 1.826 1.728 3.25 2.848 4.772C8.966 18.75 9.989 20.076 11 21.39l.207.207c.206.206.51.402.815.402.206 0 .51 0 .706-.304l.207-.207c.098-.098.195-.098.195-.195-.097 0 0 0 0 0Zm-.913-.61c-.098.099-.304.099-.402 0l-2.337-3.25c-.304-.401-.51-.706-.815-1.119-.913-1.217-1.728-2.435-2.337-3.859-.51-1.01-.706-1.826-.706-2.739 0-2.847 2.13-5.587 4.978-6.195.098 0 .098 0 .206-.098 5.076-.913 9.142 4.467 6.805 9.141a25.583 25.583 0 0 1-2.033 3.348c-.207.206-.304.51-.51.706l-2.849 4.066Z"
    />
    <path
      fill="#D11243"
      d="M12.01 12.76a2.728 2.728 0 0 0 2.74-2.738c0-1.522-1.217-2.848-2.74-2.848a2.728 2.728 0 0 0-2.738 2.74c0 1.52 1.217 2.847 2.739 2.847Z"
    />
  </Icon>
);
